import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'simple-toggle',
  templateUrl: './simple-toggle.component.html',
  styleUrls: ['./simple-toggle.component.scss'],
  standalone: false,
})
export class SimpleToggleComponent {
  private static nextId = 0;
  public inputId = `simple-toggle-${SimpleToggleComponent.nextId++}`;

  @Input() checked!: boolean;
  @Input() label?: string;
  @Input() invertLabel?: boolean;
  @Input() spaceBetween?: boolean;
  @Output() callbackOnChange = new EventEmitter<boolean>();

  handlerClick(element: Event) {
    const input = element.currentTarget as HTMLInputElement;
    this.callbackOnChange.emit(input?.checked);
  }

  /**
   * Triggered when the visual toggle element is clicked.
   * Emit the next checked state without mutating the @Input directly.
   * Parent components should update the bound [checked] value when they handle the callback.
   */
  toggleInput(): void {
    const next = !this.checked;
    this.callbackOnChange.emit(next);
  }
}
